import {
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Descriptions,
  Empty,
  Form,
  Input,
  Layout,
  List,
  Modal,
  PageHeader,
  Pagination,
  Popconfirm,
  Radio,
  Result,
  Row,
  Select,
  Skeleton,
  Space,
  Spin,
  Table,
  Tabs,
  Tag,
  Typography,
  message,
} from "antd";
import { LoadingOutlined, ReloadOutlined } from "@ant-design/icons";
import React, { Component, useState } from "react";
import {
  getClassCardBookings,
  bookClassCard,
  exportClassCardBookedStudentDetails,
  getUserFromPhone,
} from "../../store/actions/booking";
import { firestoreConnect, isEmpty, isLoaded } from "react-redux-firebase";

import { NavLink } from "react-router-dom";
import StudentInfoListItem from "../classes/components/StudentInfoListItem";
import { compose } from "redux";
import { connect } from "react-redux";
import { exportTransactions } from "../../store/actions/transaction";
import moment from "moment";
import { aws } from "../../utils/api";

const { Paragraph, Text, Link } = Typography;

class ClassCardBookings extends Component {
  state = {
    modalTimeVisible: false,
    modalBookVisible: false,
    modalBookingExportVisible: false,
    modalTxExportVisible: false,
    loading: false,
    searching: false,
    loadingBookings: false,
    currentPage: 1,
    pageSize: 10,
    filter: false,
    alreadyBooked: false,
    query: "+94",
    bookConfirmVisible: false,
    bookingCount: null,
  };

  setTimeVisible = (val) => {
    this.setState({
      modalTimeVisible: val,
    });
  };
  setBookVisible = (val) => {
    this.setState({
      modalBookVisible: val,
    });
  };
  setExportVisible = (val) => {
    this.setState({
      modalBookingExportVisible: val,
    });
  };
  setTxExportVisible = (val) => {
    this.setState({
      modalTxExportVisible: val,
    });
  };
  setBookConfirmVisible = (val) => {
    this.setState({
      bookConfirmVisible: val,
    });
  };

  searchForUser = async (phone) => {
    this.setState({ searching: true });
    await this.props.getUserFromPhone(phone);
    this.loadBookings();
    this.setState({ searching: false });
  };

  updateQuery = (e) => {
    if (e.target.value.trim().includes("+94")) {
      this.setState({ query: e.target.value });
    } else {
      this.setState({ query: "+94" });
    }
  };

  setFilter = (phone) => {
    this.setState({
      query: phone,
    });
    this.searchForUser(phone);
  };

  clearFilter = () => {
    this.setState({
      filteredData: this.props.bookings,
      filter: false,
      alreadyBooked: false,
      query: "+94",
    });
    this.loadBookings();
  };

  handleOnChangePagination = (page) => {
    this.setState({
      currentPage: page,
    })
    this.loadBookings();
  }

  loadBookings = async () => {
    this.setState({
      loadingBookings: true,
      bookingCount: null,
    });

    // update booking count
    this.fetchBookingCount();

    // query
    const entityUid = this.props.classCardId;
    const query = this.state.query;
    const userUid = this.props.user?.id; // this could exist even when cleared

    const currentPage = this.state.currentPage;
    const pageSize = this.state.pageSize;

    // load bookings
    const hasUser = query && query != '+94' && userUid;

    await this.props.getClassCardBookings({
      entityType: 'C',
      entityUid: entityUid,
      userUid: hasUser ? userUid : null,
      page: currentPage,
      size: pageSize,
    });
    const alreadyBooked = !hasUser ? false : ( this.props.bookings.length > 0 );

    // set filter values
    this.setState({
      filter: hasUser,
      alreadyBooked: alreadyBooked,
      loadingBookings: false,
    });
  }

  addBooking = async () => {
    this.setBookConfirmVisible(false);
    this.setState({ searching: true, loading: true });

    const orderId = `C_${this.props.classCardId}_${this.props.user.id}`;
    await this.props.bookClassCard(
      orderId,
      this.props.classCard.amount,
      "Initial Booking"
    );
    if (this.props.bookError) {
      message.error("There was an error: ", this.props.bookError);
    } else {
      message.success("Booking was successful");
      this.clearFilter();
    }
    this.setState({ searching: false, loading: false });
  };

  // exportBookings = async (values) => {
  //   this.setState({ loading: true });
  //   let from = values.range
  //     ? values.range[0].format("YYYY-MM-DD HH:mm:ss")
  //     : null;
  //   let to = values.range
  //     ? values.range[1].format("YYYY-MM-DD HH:mm:ss")
  //     : null;
  //   await this.props.exportClassCardBookedStudentDetails(
  //     values.type,
  //     from,
  //     to,
  //     this.props.classCard.name ?? "Class Card"
  //   );
  //   if (this.props.exportError) {
  //     message.error("There was an error");
  //   } else {
  //     message.success("Export successful");
  //   }
  //   this.setState({
  //     loading: false,
  //     modalBookingExportVisible: false,
  //   });
  // };
  // exportTx = async (values) => {
  //   this.setState({ loading: true });
  //   let from = values.range
  //     ? values.range[0].format("YYYY-MM-DD HH:mm:ss")
  //     : null;
  //   let to = values.range
  //     ? values.range[1].format("YYYY-MM-DD HH:mm:ss")
  //     : null;
  //   await this.props.exportTransactions(
  //     values.type,
  //     from,
  //     to,
  //     this.props.classCard.name
  //   );
  //   if (this.props.exportError) {
  //     message.error("There was an error");
  //   } else {
  //     message.success("Export successful");
  //   }
  //   this.setState({
  //     loading: false,
  //     modalTxExportVisible: false,
  //   });
  // };

  bookAgain = async (values) => {
    this.setState({ searching: true, loading: true });

    const orderId = `C_${this.props.classCardId}_${this.props.user.id}`;
    await this.props.bookClassCard(
      orderId,
      this.props.classCard.amount,
      values.reason
    );
    if (this.props.bookError) {
      message.error("There was an error");
    } else {
      message.success("Booking was successful");
    }
    this.setState({
      searching: false,
      loading: false,
      modalBookVisible: false,
    });
  };

  onKeyPress = async ({ keyCode }) => {
    switch (keyCode) {
      case 27: //Esc
        if (this.state.filter) this.clearFilter();
        break;
      case 81: //q
        if (
          this.state.filter &&
          !this.state.modalBookVisible &&
          !this.state.modalTimeVisible
        )
          this.setBookVisible(true);
        break;
      case 65: //a
        if (
          this.state.filter &&
          !this.state.modalTimeVisible &&
          !this.state.modalBookVisible
        )
          this.setTimeVisible(true);
        break;
      case 66: //b
        if (
          this.state.filter &&
          !this.state.bookConfirmVisible &&
          !this.state.alreadyBooked
        ) {
          const btn = document.getElementById("bookbtn");
          btn.click(); //FIXME: do this in a better way!!
        }
        break;
      case 89: //y
        if (this.state.filter && this.state.bookConfirmVisible)
          this.addBooking(true);
        break;
      case 78: //n
        if (this.state.filter && this.state.bookConfirmVisible)
          this.setBookConfirmVisible(false);
        break;

      default:
        break;
    }
  };

  fetchBookingCount = async () => {
    this.setState({
      bookingCount: null,
    });

    const classCardUid = this.props.classCardId;
    const token = this.props.token;

    if( classCardUid && token ){
      const res = await aws.post(
        "/payments/getBookingCount",
        {
          entityType: 'C',
          entityUid: classCardUid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      // set count
      const count = res?.data?.data?.count;
      this.setState({
        bookingCount: count ? count : 0,
      })
    }
  }

  componentDidMount() {
    window.addEventListener("keydown", this.onKeyPress);
    this.loadBookings();
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyPress);
  }
  render() {
    const { classCard, classCardId, bookings, user } = this.props;
    let listData = bookings;
    let selectedUser = this.state.filter ? user : null;

    if (
      classCard != null &&
      isLoaded(classCard, bookings) &&
      classCard.id === classCardId
    ) {
      return (
        <Layout>
          <PageHeader
            onBack={() => window.history.back()}
            ghost={false}
            title="Class Card Bookings"
            className="site-page-header"
          ></PageHeader>
          <Row>
            <Col sm={{ span: 24 }} md={{ span: 24 }} justify="center">
              <Card
                title={
                  <div className="class-name class-name flex flex-row space-x-4 items-center pr-4">
                    <Text>{classCard.name}</Text>
                    {
                      this.state.bookingCount == null &&
                      <LoadingOutlined />
                    }
                    {
                      this.state.bookingCount == 0 &&
                      <Tag style={{ display: "inline-block" }}>No bookings yet</Tag>
                    }
                    {
                      this.state.bookingCount > 0 &&
                      <Tag color="blue">
                          Students Booked : {this.state.bookingCount}
                        </Tag>
                    }

                    {
                      this.state.bookingCount != null && this.state.bookingCount >= 0 &&
                      <ReloadOutlined onClick={this.fetchBookingCount} />
                    }
                  </div>
                }
                style={{ margin: "1rem 1rem 1rem 1rem" }}
                extra={<Avatar shape="square" src={classCard.coverUrl} />}
              >
                <Row>
                  <Col span={24} justify="center">
                    <CustomModal
                      loading={this.state.loading}
                      visible={this.state.modalBookVisible}
                      onCreate={this.bookAgain}
                      onCancel={() => {
                        this.setBookVisible(false);
                      }}
                      title={"Booking again"}
                      okText={"Book"}
                      itemName={"reason"}
                      itemLabel={"Provide a reason for this booking"}
                    />
                    <CustomModal
                      loading={this.state.loading}
                      visible={this.state.modalTimeVisible}
                      onCancel={() => {
                        this.setTimeVisible(false);
                      }}
                      title={"Reset video play started time"}
                      okText={"Reset Time"}
                      itemName={"note"}
                      itemLabel={"Please provide a reason"}
                    />
                    <Card
                      title={"Quick Book"}
                      hoverable
                      extra={
                        this.state.filter
                          ? [
                              <Button
                                key={1}
                                onClick={this.clearFilter}
                                disabled={this.state.loading}
                              >
                                Clear Filter
                              </Button>,
                            ]
                          : []
                      }
                    >
                      <Input.Search
                        placeholder="+94123456789"
                        onSearch={(phone) => this.searchForUser(phone)}
                        onChange={this.updateQuery}
                        value={this.state.query}
                        loading={this.state.searching}
                        maxLength={12}
                        style={{ marginBottom: "10px" }}
                      />
                      {selectedUser !== null && selectedUser !== undefined ? (
                        this.state.searching ? (
                          <Spin>
                            <UserPreview user={selectedUser} />
                          </Spin>
                        ) : (
                          <UserPreview
                            user={selectedUser}
                            btn={
                              this.state.alreadyBooked ? (
                                <Space direction="vertical">
                                  <Tag color="green">Already Booked</Tag>
                                  <Button
                                    onClick={() => {
                                      this.setBookVisible(true);
                                    }}
                                  >
                                    Book Again[Q]
                                  </Button>
                                  {/* <Button
                                    onClick={() => {
                                      this.setTimeVisible(true);
                                    }}
                                  >
                                    Reset Time[A]
                                  </Button> */}
                                </Space>
                              ) : (
                                <Popconfirm
                                  title="Please confirm before adding"
                                  onConfirm={this.addBooking}
                                  onCancel={() => {
                                    this.setBookConfirmVisible(false);
                                  }}
                                  okText="[Y]es"
                                  cancelText="[N]o"
                                  style={{ float: "right" }}
                                >
                                  <Button
                                    id="bookbtn"
                                    type="primary"
                                    onClick={() =>
                                      this.setBookConfirmVisible(true)
                                    }
                                  >
                                    [B]ook
                                  </Button>
                                </Popconfirm>
                              )
                            }
                          />
                        )
                      ) : this.state.searching ? (
                        <Spin>
                          <Empty description={"Searching for a user"} />
                        </Spin>
                      ) : user !== null ? (
                        <Empty description={"No user found"} />
                      ) : null}
                    </Card>
                  </Col>
                  <Col span={24} justify="center">
                    {/* <BookingExportModal
                      loading={this.state.loading}
                      visible={this.state.modalBookingExportVisible}
                      onOk={this.exportBookings}
                      onCancel={() => {
                        this.setExportVisible(false);
                      }}
                      title={"Export Bookings"}
                      okText={"Export"}
                    />
                    <TxExportModal
                      loading={this.state.loading}
                      visible={this.state.modalTxExportVisible}
                      onOk={this.exportTx}
                      onCancel={() => {
                        this.setTxExportVisible(false);
                      }}
                      title={"Export Transactions"}
                      okText={"Export"}
                    /> */}
                    <Card
                      title={"Bookings"}
                      style={{ margin: "1rem 0 0 0 " }}
                      extra={
                        <Space>
                          <Button
                            onClick={this.loadBookings}
                            disabled={this.state.loadingBookings}
                          >
                            {
                              this.state.loadingBookings
                              ? <LoadingOutlined />
                              : <ReloadOutlined />
                            }
                          </Button>
                          <NavLink
                            to={
                              "/cards/preview/" +
                              this.props.classCardId +
                              "/bookings/import"
                            }
                            target="_blank"
                            key={1}
                          >
                            <Button>Import</Button>
                          </NavLink>
                          {/* <Button
                            onClick={() => {
                              this.setExportVisible(true);
                            }}
                            key={2}
                          >
                            Export Bookings
                          </Button> */}
                          {/* <Button
                            onClick={() => {
                              this.setTxExportVisible(true);
                            }}
                            key={3}
                          >
                            Export Transactions
                          </Button> */}
                        </Space>
                      }
                    >
                      <List
                        itemLayout="horizontal"
                        dataSource={listData}
                        pagination={
                          <Pagination current={this.state.currentPage} defaultPageSize={this.state.pageSize} onChange={this.handleOnChangePagination} />
                        }
                        renderItem={(booking) => {
                          return (
                            <StudentInfoListItem
                              uid={booking.student_uid}
                              time={booking.booked_time}
                              orderId={`P_${classCardId}_${booking.student_uid}`}
                              paymentType={booking.is_manual_booking ? 'Manual Booking' : 'Paid Booking'}
                              callback={this.setFilter}
                            />
                          );
                        }}
                      />
                    </Card>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Layout>
      );
    } else {
      return (
        <Layout>
          <PageHeader
            onBack={() => window.history.back()}
            ghost={false}
            title="Class Cards Bookings"
            className="site-page-header"
          ></PageHeader>
          <Row>
            <Col sm={{ span: 24 }} md={{ span: 24 }} justify="center">
              <Card
                title="Loading please wait..."
                style={{ margin: "1rem 1rem 0 1rem" }}
                extra={<Skeleton.Button active />}
              >
                <Skeleton active />
              </Card>
            </Col>
          </Row>
        </Layout>
      );
    }
  }
}

const UserPreview = (props) => {
  const { user, btn } = props;
  return (
    <Card>
      <Row>
        <Col flex="auto">
          <p style={{ marginBottom: ".1em", fontWeight: "bold" }}>
            {user.data().firstName + " " + user.data().lastName}
          </p>
          <p style={{ marginBottom: ".1em" }}>
            {user.data().gradeName + ", " + user.data().streamName}
          </p>
          <p style={{ marginBottom: ".1em" }}>{user.data().schoolName}</p>
        </Col>
        <Col>{btn}</Col>
      </Row>
    </Card>
  );
};

const CustomModal = ({
  loading,
  visible,
  onCreate,
  onCancel,
  title,
  okText,
  itemName,
  itemLabel,
}) => {
  const [form] = Form.useForm();
  return (
    <Modal
      destroyOnClose={true}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ disabled: loading }}
      maskClosable={false}
      visible={visible}
      title={title}
      okText={okText}
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onCreate(values);
          })
          .catch((info) => {
            // console.log("Validate Failed:", info);
          });
      }}
    >
      <Form form={form} layout="vertical" name="modal-form">
        <Form.Item
          name={itemName}
          label={itemLabel}
          rules={[
            {
              required: true,
              message: "This field cannot be empty!",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const BookingExportModal = ({
  loading,
  visible,
  onOk,
  onCancel,
  title,
  okText,
}) => {
  const [form] = Form.useForm();
  return (
    <Modal
      destroyOnClose={true}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ disabled: loading }}
      maskClosable={false}
      visible={visible}
      title={title}
      okText={okText}
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onOk(values);
          })
          .catch((info) => {
            // console.log("Validate Failed:", info);
          });
      }}
    >
      <Form form={form} layout="vertical" name="modal-form">
        <Form.Item
          name="range"
          label="Date Range"
          rules={[
            {
              required: false,
              message: "This field cannot be empty!",
            },
          ]}
        >
          <DatePicker.RangePicker showTime />
        </Form.Item>
        <Form.Item
          name="type"
          label="Type"
          rules={[
            {
              required: true,
              message: "This field cannot be empty!",
            },
          ]}
          initialValue={"ALL"}
        >
          <Select>
            <Select.Option value="ALL">ALL</Select.Option>
            <Select.Option value="MANUAL">MANUAL</Select.Option>
            <Select.Option value="ONLINE">ONLINE</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const TxExportModal = ({ loading, visible, onOk, onCancel, title, okText }) => {
  const [form] = Form.useForm();
  return (
    <Modal
      destroyOnClose={true}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ disabled: loading }}
      maskClosable={false}
      visible={visible}
      title={title}
      okText={okText}
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onOk(values);
          })
          .catch((info) => {
            // console.log("Validate Failed:", info);
          });
      }}
    >
      <Form form={form} layout="vertical" name="modal-form">
        <Form.Item
          name="range"
          label="Date Range"
          rules={[
            {
              required: false,
              message: "This field cannot be empty!",
            },
          ]}
        >
          <DatePicker.RangePicker showTime />
        </Form.Item>
        <Form.Item
          name="payment_type"
          label="Type"
          rules={[
            {
              required: true,
              message: "This field cannot be empty!",
            },
          ]}
          initialValue={"ALL"}
        >
          <Select>
            <Select.Option value="ALL">ALL</Select.Option>
            <Select.Option value="MANUAL">MANUAL</Select.Option>
            <Select.Option value="ONLINE">ONLINE</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const mapStateToProps = (state, routeProps) => {
  return {
    bookings: state.booking.classCardBookings
      ? state.booking.classCardBookings : [],
    classCard: state.firestore.ordered.selected_class_card
      ? state.firestore.ordered.selected_class_card[0]
      : null,
    classCardId: routeProps.match.params.classCardId,
    user: state.booking.users ? state.booking.users.docs[0] : null,
    bookError: state.booking.bookError,
    resetError: state.booking.resetError,
    exportError: state.booking.exportError,
    token: state.firebase.profile.token.token,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    getUserFromPhone: (phone) => dispatch(getUserFromPhone(phone)),
    getClassCardBookings: (data) => dispatch(getClassCardBookings(data)),
    bookClassCard: (orderId, amount, reason) =>
      dispatch(
        bookClassCard({
          orderId,
          amount: amount,
          reason: reason,
        })
      ),
    exportClassCardBookedStudentDetails: (type, from, to, class_card_name) =>
      dispatch(
        exportClassCardBookedStudentDetails({
          class_card_uid: props.match.params.classCardId,
          type,
          from,
          to,
          class_card_name,
        })
      ),
    // exportTransactions: (payment_type, from, to, paper_name) =>
    //   dispatch(
    //     exportTransactions({
    //       type: "CLASSCARD",
    //       classCardId: props.match.params.classCardId,
    //       payment_type,
    //       from,
    //       to,
    //       paper_name,
    //     })
    //   ),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((routeProps) => [
    {
      collection: "class_cards",
      doc: routeProps.match.params.classCardId,
      storeAs: "selected_class_card",
    }
  ])
)(ClassCardBookings);
